module.exports = __webpack_public_path__ + "static/img/naat.de2504ff.svg";